import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

interface FooterProps {
    footerClass?: string;
    sidebarWidth?: number;
}

const Footer: React.FC<FooterProps> = ({ footerClass = '', sidebarWidth = 0 }) => {
    const currentYear = new Date().getFullYear();
    const { darkMode } = useTheme();
    
    return (
        <footer 
            className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-t px-6 py-4 fixed bottom-0 left-0 right-0 z-20 transition-all duration-300 ${footerClass}`}
            style={{ 
                left: sidebarWidth > 0 ? `${sidebarWidth}px` : '0',
                transition: 'left 300ms ease-in-out'
            }}
        >
            <div className={`flex items-center justify-between text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                <div>
                    <span>© {currentYear} Legitimu. All rights reserved.</span>
                </div>
                <div className="flex items-center space-x-6">
                    <Link to="/privacy-policy" className={`transition-colors ${darkMode ? 'hover:text-violet-400' : 'hover:text-violet-600'}`}>Privacy Policy</Link>
                    <Link to="/terms-of-service" className={`transition-colors ${darkMode ? 'hover:text-violet-400' : 'hover:text-violet-600'}`}>Terms of Service</Link>
                    <Link to="/documentation" className={`transition-colors ${darkMode ? 'hover:text-violet-400' : 'hover:text-violet-600'}`}>Documentation</Link>
                    <Link to="/support" className={`transition-colors ${darkMode ? 'hover:text-violet-400' : 'hover:text-violet-600'}`}>Support</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
